import request from "@/utils/request";

export function palmGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Palm/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function palmGetAllForDropdownWithPagination(params) {
    return request({
        url: "/api/services/app/Palm/GetAllForDropdownWithPagination",
        method: "GET",
        params
    });
}

export function palmGet(params) {
    return request({
        url: "/api/services/app/Palm/Get",
        method: "GET",
        params
    });
}

export function palmGetLineage(params) {
    return request({
        url: "/api/services/app/Palm/GetLineageOfPalm",
        method: "GET",
        params
    });
}

export function palmCreate(data) {
    return request({
        url: "/api/services/app/Palm/Create",
        method: "POST",
        data
    });
}

export function palmUpdate(data) {
    return request({
        url: "/api/services/app/Palm/Update",
        method: "PUT",
        data
    });
}

export function palmDelete(params) {
    return request({
        url: "/api/services/app/Palm/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/palm.js